import { DateTime } from 'luxon'
import React, { memo } from 'react'

import TruncateLines from '@components/TruncateLines'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { StyledEventBoxWrapper } from './index.styles'

const EventNameWithArrow = (props: { eventName: string; startDate: string; endDate: string }) => {
  const { eventName, startDate, endDate } = props
  const isPastEvent = DateTime.now() > DateTime.fromISO(endDate)
  const isUpcomingEvent = DateTime.now() <= DateTime.fromISO(startDate)
  return (
    <StyledEventBoxWrapper>
      {isPastEvent && <ArrowBackIcon fontSize="small" />}
      <TruncateLines lines={4}>{eventName}</TruncateLines>
      {(isUpcomingEvent || (endDate && !isPastEvent)) && <ArrowForwardIcon fontSize="small" sx={{ marginLeft: '3px' }} />}
    </StyledEventBoxWrapper>
  )
}

export default memo(EventNameWithArrow)
